import type React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGTextElement> & {
  textAnchor?: 'start' | 'end' | 'middle';
  value: string;
};

export const TickLabel: React.FC<Props> = ({
  x,
  y,
  value,
  textAnchor = 'middle',
  fontSize,
  ...props
}) => {
  return (
    <text
      {...props}
      x={x}
      y={y}
      textAnchor={textAnchor}
      style={{
        whiteSpace: 'nowrap',
      }}
      fontSize={fontSize}
    >
      {value}
    </text>
  );
};
